import Store from './interfaces/Store';
import RestStore from './RestStore';
import IndexedDBStore from './IndexedDBStore';
import config from '../config';

const dataSources = {
  INDEXED_DB: 0,
  NETWORK: 1
};

let cache = {
  users: [],
  events: [],
  dishes: [],
  products: [],
  reservations: [],
  notifications: [],
  currentUser: {},
  driverShifts: []
};

let dbStore;
let restStore;

let cacheResolvers = [];
let indexDBInitialized = false;
let restInitialized = false;
let cacheInitialized = false;

export default class RdsStore extends Store {
  constructor() {
    super();
    restStore = new RestStore();
    dbStore = new IndexedDBStore();

    window.getUsers = function () {
      return dbStore.getAll('rdsUser');
    };
    window.getUser = function (id) {
      return dbStore.get('rdsUser', id);
    };

    const restPromise = restStore.getAll();
    let types = config.models.map((m) => m.objectStoreName);
    let getAllPromises = [];
    for (const type of types) {
      getAllPromises.push(dbStore.getAll(type));
    }
    Promise.all(getAllPromises).then(values => [].concat.apply([], values))
      .then(data => dataToModels(data))
      .then(data => toChache(data, dataSources.INDEXED_DB))
      .then((data) => {
        indexDBInitialized = true;
        console.log('indexDBInitialized');
        if (restInitialized) {
          cacheInitialized = true;
          console.log('cacheInitialized');

          getCache().then(console.log());
        }
      });
    restPromise.then(response => response.json())
      .then(response => response.data.Items)
      .then(data => removeDeleted(data))
      .then(data => syncIndexedDB(data))
      .then(data => normalizeAwsData(data))
      .then(data => dataToModels(data))
      .then(data => toChache(data, dataSources.NETWORK))
      .then((data) => {
        restInitialized = true;
        console.log('restInitialized');
        if (indexDBInitialized) {
          console.log('cacheInitialized');
          cacheInitialized = true;
          getCache().then(console.log());
        }
      })
      .catch((e) => {
        console.log(e);
      });
    setInterval(() => {
      restStore.getAll().then(response => response.json())
        .then(response => response.data.Items)
        .then(data => removeDeleted(data))
        .then(data => syncIndexedDB(data))
        .then(data => normalizeAwsData(data))
        .then(data => dataToModels(data))
        .then(data => toChache(data, dataSources.NETWORK))
        .then((data) => {
          // cacheInitialized = true;
          getCache().then(console.log);
        })
        .catch((e) => {
          console.log(e);
        });
    }, 30000);
  }

  get cache() {
    return cache;
  }

  getAll(type) {
    return new Promise((resolve, reject) => {
      getCache().then(() => {
        let cacheName = config.models.find((m) => m.name === type).cacheObject;
        let cacheArray = cache[cacheName];
        resolve(cacheArray);
      });
    });
  }
  get(type, id, forceReload) {
    return new Promise((resolve, reject) => {
      getCache().then(() => {
        let cacheName = config.models.find((m) => m.name === type).cacheObject;
        let cacheArray = cache[cacheName];
        let item = cacheArray.find((i) => i.id === id);
        console.log('get', item);
        if (forceReload) {
          item = null;
        }
        if (item) {
          resolve(item);
        }
        if (!item) {
          restStore.get(type, id)
            .then(response => response.json())
            .then(response => response.data.Items)
            .then(data => syncIndexedDB(data))
            .then(data => normalizeAwsData(data))
            .then(data => dataToModels(data))
            .then(data => toChache(data, dataSources.NETWORK))
            .then(data => {
              for (const key in data) {
                if (data.hasOwnProperty(key)) {
                  resolve(data[key][0]);
                }
              }
            });
        }
      });
    });
  }

  add(type, obj) {
    return new Promise((resolve, reject) => {
      getCache().then(() => {
        // let cacheName = config.models.find((m) => m.name === type).cacheObject;
        // let cacheArray = cache[cacheName];

        // cacheArray.push(obj);
        restStore.add(type, obj)
          .then(obj => [obj.data])
          .then(data => syncIndexedDB(data))
          .then(data => normalizeAwsData(data))
          .then(data => dataToModels(data))
          .then(data => toChache(data, dataSources.NETWORK))
          .then(data => {
            for (const key in data) {
              if (data.hasOwnProperty(key)) {
                resolve(data[key][0]);
              }
            }
          });
        // .then((data) => {
        //   // dbStore.add(type, newObj).then(console.log);
        //   resolve(data[0]);
        // });
      });
    });
  }

  update(type, id, obj) {
    return new Promise((resolve, reject) => {
      getCache().then(() => {
        let cacheName = config.models.find((m) => m.name === type).cacheObject;
        let cacheArray = cache[cacheName];
        let idx = cacheArray.findIndex((o) => o.id === id);
        Object.assign(cacheArray[idx], obj);
        dbStore.update(type, obj).then(console.log);
        restStore.update(type, id, obj).then(() => { resolve(obj); });
      });
    });
  }

  remove(type, id) {
    return new Promise((resolve, reject) => {
      getCache().then(() => {
        let cacheName = config.models.find((m) => m.name === type).cacheObject;
        let cacheArray = cache[cacheName];
        let idx = cacheArray.findIndex((o) => o.id === id);
        cacheArray.splice(idx, 1);
        dbStore.delete(type, id).then(console.log);
        restStore.delete(type, id).then(() => { resolve(); });
      });
    });
  }
}

function toChache(data, dataSource) {
  for (const key in cache) {
    if (cache.hasOwnProperty(key)) {
      const prop = cache[key];
      if (data.hasOwnProperty(key)) {
        if (Array.isArray(prop)) {
          let merge = [];
          if (dataSource === dataSources.NETWORK) {
            merge = data[key].concat(prop);
          } else {
            merge = prop.concat(data[key]);
          }
          cache[key] = merge.filter((obj, idx, arr) => arr.findIndex((item) => item.id === obj.id) === idx);
        } else if (typeof prop === 'object') {
          let merge = {};
          if (dataSource === dataSources.NETWORK) {
            Object.assign(merge, prop, data[key]);
          } else {
            Object.assign(merge, data[key], prop);
          }
          Object.assign(cache[key], merge);
        }
      }
    }
  }
  return data;
}

function normalizeAwsData(data) {
  return data.map(i => {
    let content = i.content;
    content.id = isNaN(Number(i.id)) ? i.id : Number(i.id);
    return content;
  });
}
// function normalizeAwsObject(obj) {
//   let content = obj.content;
//   content.id = isNaN(Number(obj.id)) ? obj.id : Number(obj.id);
//   return content;
// }

function dataToModels(data) {
  let mappendData = {};
  const tipologie = data.map(item => item.tipologia).filter((tipologia, idx, arr) => arr.indexOf(tipologia) === idx);
  for (const tipologia of tipologie) {
    let items = data.filter(i => i.tipologia === tipologia);
    let modelType = config.models.find((m) => m.name === tipologia);
    if (!!!modelType) {
      continue;
    }
    let cacheName = modelType.cacheObject;
    let Clazz = modelType.class;
    mappendData[cacheName] = [];
    let inject = [];
    if (!!modelType.inject) {
      for (let i = 0; i < modelType.inject.length; i++) {
        const element = modelType.inject[i];
        let toConcat = [];
        if (mappendData && mappendData[element] && mappendData[element].length) {
          toConcat = mappendData[element];
        }
        const toInject = cache[element].concat(toConcat);
        inject[element] = toInject;
      }
    }
    for (const item of items) {
      const typedObj = new Clazz(item, inject);
      mappendData[cacheName].push(typedObj);
    }
  }

  return mappendData;
}

function removeDeleted(data) {
  let items = data.filter(i => i.visibility === 'private');
  for (const item of items) {
    const id = item.content.id = isNaN(Number(item.id)) ? item.id : Number(item.id);
    const modelType = config.models.find((m) => m.name === item.tipologia);
    try {
      const cacheName = modelType.cacheObject;
      cache[cacheName] = cache[cacheName].filter(i => i.id !== id);
      dbStore.delete(item.tipologia, id);
    } catch (error) {
      console.warn(error);

    }
  }
  return data.filter(i => i.visibility === 'public');
}

function syncIndexedDB(remoteData) {
  let data = remoteData.map((d) => {
    d.content.id = isNaN(Number(d.id)) ? d.id : Number(d.id);
    return d.content;
  });
  const tipologie = data.map(item => item.tipologia).filter((tipologia, idx, arr) => arr.indexOf(tipologia) === idx);
  for (const tipologia of tipologie) {
    if (config.models.filter((m) => m.name === tipologia).length < 1) {
      continue;
    }
    let items = data.filter(i => i.tipologia === tipologia);
    for (const item of items) {
      dbStore.update(tipologia, item);
    }
  }
  return remoteData;
}

function getCache() {
  return new Promise((resolve, reject) => {
    if (!cacheInitialized) {
      cacheResolvers.push(resolve);
    } else {
      for (let i = 0; i < cacheResolvers.length; i++) {
        cacheResolvers[i](cache);
      }
      cacheResolvers = [];
      resolve(cache);
    }
  });
}
